import { CloseButton, Form, InputGroup } from 'react-bootstrap'
import React, { memo, useEffect, useRef } from 'react'

import { PreviewFile } from './PreviewFile'
import PropTypes from 'prop-types'
import { XStack } from '../../../index.style'
import { blobToFile } from '../../../utils'
import { useField } from 'formik'

const UploadImageField = ({ label, defaultUrl, ...props }) => {
  const [field, meta, helper] = useField(props.name)
  const { value, ...restField } = field

  const inputRef = useRef(null)

  useEffect(() => {
    let isMounted = true

    const fetchData = async () => {
      const blob = await fetch(defaultUrl).then((r) => r.blob())

      if (isMounted) {
        const file = await blobToFile(blob, 'highlight-lottery')
        helper.setValue(file)
      }
    }

    if (defaultUrl) {
      fetchData().catch(console.error)
    }

    return () => {
      isMounted = false
    }
  }, [defaultUrl, helper])

  useEffect(() => {
    if (!value) {
      inputRef.current.value = ''
    }
  }, [value])

  const handleOnChange = (event) => {
    if (event.currentTarget.files[0]) {
      helper.setValue(event.currentTarget.files[0])
    } else {
      helper.setValue(null)
    }
  }

  const handleRemoveImage = () => {
    helper.setValue(null)
  }

  return (
    <Form.Group className="position-relative mb-3">
      <Form.Label as={'b'}>{label}</Form.Label>
      <InputGroup hasValidation>
        <Form.Control
          ref={inputRef}
          type="file"
          accept="image/png"
          {...restField}
          {...props}
          onChange={handleOnChange}
          isInvalid={meta.error && meta.touched}
        />
        <Form.Control.Feedback type="invalid">{meta.error}</Form.Control.Feedback>
      </InputGroup>
      {value && (
        <XStack style={{ gap: 16 }}>
          <PreviewFile height="auto" file={value} />
          <CloseButton
            onClick={handleRemoveImage}
            style={{
              position: 'absolute',
              top: 64,
              right: 0,
              backgroundColor: '#f94687',
              padding: 8,
              paddingLeft: 12,
              paddingRight: 12,
              borderRadius: 32,
              color: 'white',
              opacity: 1,
            }}
          />
        </XStack>
      )}
    </Form.Group>
  )
}

export default memo(UploadImageField)

UploadImageField.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  defaultUrl: PropTypes.string,
}
